import jwtDecode from 'jwt-decode';
import {axiosInstance} from '../api/axios/AxiosInstance';
import {store} from '../app/store';
import {setBearerToken, setRefreshToken} from '../features/user/userSlice';

export function isRefreshTokenValid() {
  if (!window.localStorage.getItem('refreshToken')) {
    return false;
  }
  let {exp} = jwtDecode(window.localStorage.getItem('refreshToken'));

  if (Date.now() >= exp * 1000) {
    console.log('refresh token valid false');
    window?.localStorage.clear();
    //make a refreshToken call here.
    return false;
  } else {
    console.log('token valid true');
    //route to homepage
    return true;
  }
}

export function checkBearerTokenValidity(userName, navigate) {
  if (window.localStorage?.getItem('bearerToken')) {
    let {exp} = jwtDecode(window.localStorage.getItem('bearerToken'));
    let refToken = window?.localStorage?.getItem('refreshToken');

    if (Date.now() >= exp * 1000) {
      console.log('bearer token valid false');
      window?.localStorage.removeItem('bearerToken');
      if (isRefreshTokenValid()) {
        axiosInstance
          .get(`/auth/refresh/UserName=${userName}&RefreshToken=${refToken}`)
          .then(res => {
            //set new bearer and refresh token
            window.localStorage?.setItem('refreshToken', res.data?.RefreshToken);
            window.localStorage?.setItem('bearerToken', res.data?.BearerToken);
            store.dispatch(setRefreshToken(res.data?.RefreshToken));
            store.dispatch(setBearerToken(res.data?.BearerToken));
          });
      } else {
        //logout
        window.localStorage?.clear();
        navigate('/');
      }
    } else {
      console.log('token valid true');
    }
  }
}
